var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 7.60834C6.90625 7.60834 6.60156 7.98334 5.5 7.98334C4.375 7.98334 4.07031 7.60834 3.39062 7.60834C1.65625 7.60834 0.25 9.03802 0.25 10.7724V11.7333C0.25 12.3661 0.742188 12.8583 1.375 12.8583H9.625C10.2344 12.8583 10.75 12.3661 10.75 11.7333V10.7724C10.75 9.03802 9.32031 7.60834 7.58594 7.60834ZM10 11.7333C10 11.9443 9.8125 12.1083 9.625 12.1083H1.375C1.16406 12.1083 1 11.9443 1 11.7333V10.7724C1 9.43646 2.05469 8.35834 3.39062 8.35834C3.85938 8.35834 4.30469 8.73334 5.5 8.73334C6.67188 8.73334 7.14062 8.35834 7.58594 8.35834C8.92188 8.35834 10 9.43646 10 10.7724V11.7333ZM5.5 6.85834C7.14062 6.85834 8.5 5.5224 8.5 3.85834C8.5 2.21771 7.14062 0.858337 5.5 0.858337C3.83594 0.858337 2.5 2.21771 2.5 3.85834C2.5 5.5224 3.83594 6.85834 5.5 6.85834ZM5.5 1.60834C6.71875 1.60834 7.75 2.63959 7.75 3.85834C7.75 5.10052 6.71875 6.10834 5.5 6.10834C4.25781 6.10834 3.25 5.10052 3.25 3.85834C3.25 2.63959 4.25781 1.60834 5.5 1.60834Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.809494c8.svg";
export { ForwardRef as ReactComponent };